$(document).ready(function(){

  if(window.location.href.indexOf('portfolio-directory') !== -1) {
    handleIllustratorLocations();
  }

  function handleIllustratorLocations() {
    $.ajax({
      url: 'illustrators-locations' + window.location.search,
      type: 'GET',
      dataType: 'json',
      success: function (locations) {
        displayLocations(locations);
      },
    });
  }

  function displayLocations(locations) {
    let selectedCountries = $('#countries_list').data('countries');
    selectedCountries = selectedCountries ? selectedCountries : [];

    locations.forEach(function(location) {
      var template = $('.country_template').first().clone();

      template.find('input').val(location.id);
      template.find('input').attr('id', 'post-filter' + location.id);
      template.find('label').text(location.name);
      template.find('label').attr('for', 'post-filter' + location.id);

      if (selectedCountries.indexOf(location.id + '') !== -1) {
        template.find('input').prop('checked', true);
      }

      template.removeClass('country_template');

      template.css('display', 'block');
      $('#countries_list').append(template);
    });
  }
});